import React from "react";
import {
  ArrayField,
  Datagrid,
  ShowProps,
  TextField,
  UrlField,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import OwnershipField from "components/OwnershipField";
import StatusField from "../../components/StatusField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const Summary = (props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Vehicle Detail
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Registration Company">
            <TextField source="registrationCompany" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={2}>
          <CustomLabeled name="Registration Date">
            <CustomDateField source="registrationDate" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={2}>
          <CustomLabeled name="Deregistration Date">
            <CustomDateField source="deRegistrationDate" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Plate Number">
            <TextField source="plateNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={2}>
          <CustomLabeled name="Chassis Number">
            <TextField source="chassisNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={2}>
          <CustomLabeled name="Engine Number">
            <TextField source="engineNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={2}>
          <CustomLabeled name="Seat Capacity">
            <TextField source="seatCapacity" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <OwnershipField />

        <Grid item xs={3}>
          <CustomLabeled name="Livery">
            <TextField source="livery" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Status">
            <StatusField source="status" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Iu Number">
            <TextField source="iuNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Old Iu Number">
            <TextField source="iuNumberOld" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Document Details
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <ArrayField source="documents" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="type" emptyText="-" />
              <TextField source="serialNumber" emptyText="-" />
              <CustomDateField source="expiryDate" />
              <UrlField source="fileUrl" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={6}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
